import React from "react";

export default class DefaultPage extends React.Component {
  render() {
    return (
      <div style={{ padding: "20px", fontSize: "larger", maxWidth: "800px", margin: "0 auto" }}>
        <div style={{ fontSize: "larger", marginBottom: "20px" }}>
          Welcome to <b>WatchCast</b> by{" "}
          <a href="mailto:faithbit@gmail.com">Aryeh Tuchfeld</a>.
        </div>
        <div style={{ paddingTop: "4px", marginBottom: "30px" }}>
          <img src="/images/WC_Logo.png" alt="WatchCast Logo" />
        </div>
        <div style={{ fontSize: "large", marginBottom: "20px" }}>
          <h2>Available Pages:</h2>
          <ul style={{ listStyleType: "none", padding: 0 }}>
            <li style={{ marginBottom: "15px" }}>
              <a 
                href="/comments/?title=test_room" 
                style={{ 
                  fontSize: "1.2em", 
                  textDecoration: "none",
                  color: "#007bff",
                  fontWeight: "bold"
                }}
              >
                💬 Comments Room
              </a>
              <div style={{ fontSize: "0.9em", color: "#666", marginTop: "5px" }}>
                Join discussion rooms and leave comments
              </div>
            </li>
            <li style={{ marginBottom: "15px" }}>
              <a 
                href="/tnc" 
                style={{ 
                  fontSize: "1.2em", 
                  textDecoration: "none",
                  color: "#007bff",
                  fontWeight: "bold"
                }}
              >
                📖 Bible English Search (TNC)
              </a>
              <div style={{ fontSize: "0.9em", color: "#666", marginTop: "5px" }}>
                Search the Bible in English
              </div>
            </li>
            <li style={{ marginBottom: "15px" }}>
              <a 
                href="/monitor" 
                style={{ 
                  fontSize: "1.2em", 
                  textDecoration: "none",
                  color: "#007bff",
                  fontWeight: "bold"
                }}
              >
                📊 Monitor
              </a>
              <div style={{ fontSize: "0.9em", color: "#666", marginTop: "5px" }}>
                Monitor active rooms and participants
              </div>
            </li>
            <li style={{ marginBottom: "15px" }}>
              <a 
                href="/csm/Aryeh_FL_Songs.htm" 
                style={{ 
                  fontSize: "1.2em", 
                  textDecoration: "none",
                  color: "#007bff",
                  fontWeight: "bold"
                }}
              >
                🎵 My Songs Productions
              </a>
              <div style={{ fontSize: "0.9em", color: "#666", marginTop: "5px" }}>
                FL Studio songs and Karaokes with presentation clips
              </div>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DefaultPage.js